























import { Component, Vue, Prop } from 'vue-property-decorator'
import Disclaimer from './Components/disclaimer.vue'
import Term from './Components/term.vue'
import Privacy from './Components/privacy.vue'
import AppInfo from './Components/appInfo.vue'
import AppTutorial from './Components/appTutorial.vue'
@Component({
  name: 'OtherContent',
  components: {
    disclaimer: Disclaimer,
    term: Term,
    privacy: Privacy,
    'app-info': AppInfo,
    'app-tutorial': AppTutorial,
  },
})
export default class extends Vue {}
